import React from "react";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  gridItem: {
    marginBottom: theme.spacing() * 2,
    "&:not(:last-child)": {
      paddingRight: theme.spacing(),
    },
  },
  section: {
    marginBottom: theme.spacing(),
    marginTop: theme.spacing() * 2,
    "&:first-child": {
      marginTop: 0,
    },
  },
  subSection: {
    marginBottom: theme.spacing() * 3,
  },
}));

export default ({
  contact,
  updateContactEmail,
  updateContactPhoneNumber,
  updateContactFirstName,
  updateContactLastName,
  updateContactAddress,
  updateContactAddress2,
  updateContactCity,
  updateContactState,
  updateContactZip,
  isPrint,
}) => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h5" className={classes.section}>
        Contact Information
      </Typography>
      <Typography
        variant="subtitle1"
        color="textSecondary"
        className={classes.subSection}
      >
        Your return shipping address and contact information.
      </Typography>
      <Grid container>
        <Grid item xs={12} md={6} className={classes.gridItem}>
          <FormControl fullWidth>
            <InputLabel htmlFor="contact-first-name">First Name</InputLabel>
            <Input
              id="contact-first-name"
              type="text"
              defaultValue={contact.firstName}
              onInput={updateContactFirstName}
              maxLength={200}
              fullWidth
              required
              readOnly={!!isPrint}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6} className={classes.gridItem}>
          <FormControl fullWidth>
            <InputLabel htmlFor="contact-last-name">Last Name</InputLabel>
            <Input
              id="contact-last-name"
              type="text"
              defaultValue={contact.lastName}
              onInput={updateContactLastName}
              maxLength={200}
              fullWidth
              required
              readOnly={!!isPrint}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={7} className={classes.gridItem}>
          <FormControl fullWidth>
            <InputLabel htmlFor="contact-email">Email</InputLabel>
            <Input
              id="contact-email"
              type="email"
              defaultValue={contact.email}
              onInput={updateContactEmail}
              maxLength={200}
              fullWidth
              required
              readOnly={!!isPrint}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={5} className={classes.gridItem}>
          <FormControl fullWidth>
            <InputLabel htmlFor="contact-phone-number">Phone Number</InputLabel>
            <Input
              id="contact-phone-number"
              type="text"
              defaultValue={contact.phoneNumber}
              onInput={updateContactPhoneNumber}
              maxLength={200}
              fullWidth
              required
              readOnly={!!isPrint}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={7} className={classes.gridItem}>
          <FormControl fullWidth>
            <InputLabel htmlFor="contact-address">Address</InputLabel>
            <Input
              id="contact-address"
              type="text"
              defaultValue={contact.address}
              onInput={updateContactAddress}
              maxLength={200}
              fullWidth
              required
              readOnly={!!isPrint}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={5} className={classes.gridItem}>
          <FormControl fullWidth>
            <InputLabel htmlFor="contact-address2">Address 2</InputLabel>
            <Input
              id="contact-address2"
              type="text"
              defaultValue={contact.address2}
              onInput={updateContactAddress2}
              maxLength={200}
              fullWidth
              readOnly={!!isPrint}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6} className={classes.gridItem}>
          <FormControl fullWidth>
            <InputLabel htmlFor="contact-city">City</InputLabel>
            <Input
              id="contact-city"
              type="text"
              defaultValue={contact.city}
              onInput={updateContactCity}
              maxLength={200}
              fullWidth
              required
              readOnly={!!isPrint}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={3} className={classes.gridItem}>
          <FormControl fullWidth>
            <InputLabel htmlFor="contact-state">State / Region</InputLabel>
            <Input
              id="contact-state"
              type="text"
              defaultValue={contact.state}
              onInput={updateContactState}
              maxLength={200}
              fullWidth
              required
              readOnly={!!isPrint}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={3} className={classes.gridItem}>
          <FormControl fullWidth>
            <InputLabel htmlFor="contact-zip">Zip / Postal Code</InputLabel>
            <Input
              id="contact-zip"
              type="text"
              defaultValue={contact.zip}
              onInput={updateContactZip}
              maxLength={200}
              fullWidth
              required
              readOnly={!!isPrint}
            />
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
};
